<script>
import { VBtn, VChip, VImg, VRow, VCol, VTextField, VSwitch, VDatePicker, VSheet, VCard, VCardText, VCardTitle } from 'vuetify/lib';
import { addOrUpdateStyle } from '../util.js';
import components from '../component.js'

export default {
    name: 'zoezi-vue-component',

    zoezi: {
        title: 'Vue component',
        icon: 'mdi-vuejs'
    },
    props: {
        vue: {
            title: 'Vue code',
            type: Object,
            fulltype: 'vue',
            default: () => ({
                html:
                    `<v-btn color="primary" @click="inc">
  ${window.$translate('Click here')} ({{count}})
</v-btn>
`,
                js:
                    `{
  data: () => ({
    count: 1
  }),
  methods: {
    inc() {
      this.count++;
    }
  }
}`,
                css: ''
            })
        }
    },
    data: () => ({
        compiledComponent: null
    }),
    watch: {
        vue: {
            immediate: true,
            handler(newValue) {
                this.updateComponent(newValue);
            }
        }
    },
    methods: {
        updateComponent(vueData) {
            let compiled = components.getCompiler().compileToFunctions(vueData.html);

            // Strip 'export default' from the js code
            let componentCode = vueData.js.replace(/export\s+default\s+/, '');

            // Create the component object
            let component;
            try {
                component = new Function(`return ${componentCode}`)();
            } catch (e) {
                console.error('Error creating component:', e);
                // Fallback component or error handling
                component = { template: '<div>Error creating component</div>' };
            }
            component.render = compiled.render;
            component.staticRenderFns = compiled.staticRenderFns;
            component.components = {
                VBtn, VChip, VImg, VRow, VCol, VTextField, VSwitch, VDatePicker, VSheet, VCard, VCardText, VCardTitle
            };
            this.compiledComponent = component;

            addOrUpdateStyle('zoezi-style-' + this._uid, vueData.css);
        }
    },
    render(h) {
        if (!this.compiledComponent) {
            return h('div');
        }
        return h(this.compiledComponent, { props: {} });
    }
}
</script>
